import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

export default function SsoPrelogin() {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const idpUrl = searchParams.get('idpUrl');
    const returnTo = searchParams.get('returnTo');
    const returnToken = searchParams.get('returnToken');

    // Store return info so we can redirect back after OIDC callback
    if (returnTo) {
      localStorage.setItem('externalReturnTo', returnTo);
      if (returnToken) {
        localStorage.setItem('externalReturnToken', returnToken);
      }
    }

    if (idpUrl) {
      window.location.href = idpUrl;
    }
  }, []);

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50">
      <div className="text-gray-500">Redirecting to login...</div>
    </div>
  );
}
